import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';

const Header = ({ animate }: { animate: boolean }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { t } = useTranslation('nawy-now');

  useEffect(() => {
    if (animate && containerRef.current) {
      gsap.to(containerRef.current, {
        y: -200,
        height: 0,
        opacity: 0,
        duration: 1,
        ease: 'power2.inOut',
        pointerEvents: 'none'
      });
    } else if (containerRef.current) {
      gsap.to(containerRef.current, {
        y: 0,
        opacity: 1,
        pointerEvents: 'auto',
        height: 'auto'
      });
    }
  }, [animate]);

  useEffect(() => {
    if (containerRef.current && isMobile) {
      gsap.fromTo(
        containerRef.current,
        {
          y: -200,
          height: 0,
          opacity: 0,
          duration: 1,
          pointerEvents: 'none'
        },
        {
          y: 0,
          height: 'auto',
          opacity: 1,
          duration: 1.2,
          ease: 'back.out(3)',
          pointerEvents: 'all'
        }
      );
    }
  }, []);

  return (
    <Container ref={containerRef}>
      <h1>{t('nawy_now_header')}</h1>
      <h2>{t('nawy_now_subheader')}</h2>
      <span className="subtitle">{t('nawy_now_subtitle')}</span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #2c3138;
  /* margin-top: 10px; */
  h1,
  h2 {
    font-family: materialBold;
    font-size: 58px;
    line-height: 68px;
    text-transform: uppercase;
  }
  h1 {
    color: #ff5e00;
  }

  .subtitle {
    text-align: center;
    font-family: materialLight;
    font-size: 24px;
    line-height: 30px;
    text-transform: capitalize;
    max-width: 630px;
    margin-top: 16px;
  }

  @media screen and (max-width: 768px) {
    h1,
    h2 {
      font-size: 26px;
      line-height: 34px;
    }

    h2{
      margin-bottom: 4px ;
    }

    .subtitle {
      font-size: 14px;
      line-height: 23px;
      max-width: 335px;
      margin-top: 0;
    }
  }
`;

export default Header;
